import { dekodiereHtmlEntities } from './emailHtml';

// Klartext aus E-Mail-HTML — für AUSWERTUNGEN (Signatur, Telefonnummer, KI-Kontext).
// Bewusst getrennt von htmlZuText (lib/aktionen/platzhalter.ts): das dort ist auf das
// Zitieren im Composer getunt und macht nur aus <br> einen Zeilenumbruch. Outlook & Co.
// setzen aber jede Zeile in ein eigenes <div>/<p> — ohne Umbruch daran klebt die ganze
// Signatur in EINER Zeile, und zeilenweise Auswertung („Tel.: …") findet nichts mehr.
const BLOCK_ENDE = /<\/(p|div|tr|li|h[1-6]|blockquote|table|ul|ol|section|article)\s*>/gi;

export function mailKlartext(html: string | null | undefined): string {
  if (!html) return '';
  const roh = html
    .replace(/<(script|style|head)[\s\S]*?<\/\1\s*>/gi, ' ')
    .replace(/<!--[\s\S]*?-->/g, ' ')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(BLOCK_ENDE, '\n')
    .replace(/<t[dh]\b[^>]*>/gi, ' ') // Tabellenzellen nicht zusammenkleben
    .replace(/<[^>]+>/g, '');
  return dekodiereHtmlEntities(roh)
    .split('\n')
    .map((zeile) => zeile.replace(/[ \t ]+/g, ' ').trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
